export enum getGenericVehicleByRegistrationErrors {
  ErrLicensePlateNotSupported = 'ErrLicensePlateNotSupported',
  ErrInvalidRegistrationFormat = 'ErrInvalidRegistrationFormat',
  ErrCountryNotSupported = 'ErrCountryNotSupported'
}
